// extracted by mini-css-extract-plugin
module.exports = {"title":"RelatedBlogs_title__0L6i9","cards__wrapper":"RelatedBlogs_cards__wrapper__lhfwm","related__blogs":"RelatedBlogs_related__blogs__9lIes"};